/*
 * @Author: likk
 * @Date: 2023-11-26 20:22:32
 * @LastEditTime: 2023-11-29 14:57:53
 * @LastEditors: likk
 * @Description: 
 */
const state = {
  footBarAct:"/h5/last-review/intro",
  awardCeremBarAct:'',
}
const mutations = {
  SET_BAR_ACT: (state, data) => {
    state.footBarAct= data;
  },
  SET_AWARDCEREM_BAR_ACT:(state,data) => {
    state.awardCeremBarAct=data;
  }
}
const actions = {
  /**
   * @Author: likk
   * @description: 存储数据
   * @param {*}
   * @return {*}
   */    
  setBarAct({ commit }, data){
    commit('SET_BAR_ACT',data)
  },
  setAwardCeremBarAct({commit},data){
    commit('SET_AWARDCEREM_BAR_ACT',data)
  }

  
}
export default {
  namespaced:true,
  state,
  mutations,
  actions
};